function rangeToDayPassed({
    from, to,
}: {
    from: Date, to: Date,
}): number {
    return Math.floor(
        (to.getTime() - from.getTime()) / 1000 / 60 / 60 / 24,
    )
}

export default rangeToDayPassed
